<template>
  <div class="bg-white rounded-lg mb-6 p-6">
    <h3 class="text-2xl font-medium mb-6">Module</h3>
    <pl-select name="filter_menu" id="filter_menu" class="w-full text-sm mb-4" v-model="module.type">
      <option :value="null" disabled>Select a module</option>
      <option value="simple-cta">Call to Action - Link</option>
      <option value="call-to-action">Call to Action - Form</option>
      <option value="ticket-event-booking">Conference Ticket Booking</option>
      <option value="media">Media</option>
      <option value="latest-ezine">Latest Ezine</option>
      <option value="latest-page-turner">Latest Page Turner</option>
      <option value="valuation-mailer">Valuation Mailer</option>
      <option value="gold-marketing-pack">Gold Marketing Pack</option>
      <option value="digital-hub-link">Digital Hub Link</option>
      <option value="page-turners">Page Turners</option>
      <option value="offerhive">Offerhive</option>
      <option value="insight">Insight</option>
      <option value="FeeStreet">FeeStreet</option>
      <option value="leadPro-status">LeadPro Status</option>
      <option value="leadPro-status-office-based">LeadPro Status - Membership Ids</option>
      <option value="movebutler-single-sign-on">MoveButler Sign On</option>
      <option value="nurtur-single-sign-on">Learning Platform</option>
      <option value="qr-code-module">QR Code Settings</option>
      <option value="knowledgehub">Knowledge Hub</option>
      <option value="custom-print-module">Print Order</option>
    </pl-select>
    <button
      @click="moduleSelected"
      class="bg-secondary text-primary h-10 px-4 uppercase text-xs font-medium w-full flex items-center justify-center"
      :class="{ 'cursor-not-allowed opacity-50': !typeSelected }"
      :disabled="!typeSelected"
    >
      <span class="text-lg mr-2">&#43;</span>
      Add Module
    </button>
  </div>
</template>

<script>
export default {
  components: {},

  data () {
    return {
      module: { title: null, type: null, settings: {}, permissions: null }
    }
  },
  computed: {
    typeSelected () {
      return this.module.type !== null
    }
  },
  methods: {
    moduleSelected () {
      switch (this.module.type) {
        case 'call-to-action':
          this.$set(this.module.settings, 'elements', [])
          break
        case 'media':
          // this.$set(this.module, 'title', 'Related Media')
          this.$set(this.module.settings, 'contents', [{ path: null, filename: null, description: null }])
          this.$set(this.module.settings, 'videos', [{ title: null, src: null }])
          this.$set(this.module.settings, 'intro', null)
          this.$set(this.module.settings, 'outro', null)
          break
        case 'qr-code-module':
          this.$set(this.module.settings, 'icon', 'qrcode-icon')
          this.$set(this.module.settings, 'description', 'Unique customisable QR codes can be made in the Digital Hub. Frequently used QR codes can be automatically created and uploaded into the Hub for you, please check the links used for these QR codes are correct by clicking the link below. Any changes to the populated information will need to requested by contacting support@guildproperty.co.uk as theses details are pulled in from you registered Offcei details on the main database.')
          this.$set(this.module.settings, 'cta', 'Check My QR Code Links')
          break
        case 'custom-print-module':
          this.$set(this.module.settings, 'category', null)
          this.$set(this.module.settings, 'product', null)
          this.$set(this.module.settings, 'action', 'Order Now')
          break
        case 'ticket-event-booking':
          this.module.title = 'Book Conference Ticket'
          this.$set(this.module.settings, 'icon', 'confirm_tick')
          this.$set(this.module.settings, 'cta', 'Book Tickets')
          break
      }
      this.$emit('click', this.module)
    }
  }
}
</script>
